import { render, staticRenderFns } from "./orderDIFOTBreakdownWidget.vue?vue&type=template&id=4e44a7d0&"
import script from "./orderDIFOTBreakdownWidget.vue?vue&type=script&lang=js&"
export * from "./orderDIFOTBreakdownWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports